import Boards from './boards';

export default Boards;